export default __webpack_public_path__ + "static/media/TotalDashboardIcon.0d25b4d5.svg";